import axios from 'axios';

export function deleteAttribute({
  id
}) {
  const url =  `/serialnumber/api/v1/product/attribute/delete/${id}`;

  return new Promise((resolve, reject) => {
    axios.delete(url)
      .then(response => resolve(response.data))
      .catch(error => reject(error.response.data))
  })
}